import './Highlights.css';
export default {
    "wrapper": "Highlights_wrapper__1diyr",
    "highlightItem": "Highlights_highlightItem__1diyr",
    "ageRestriction": "Highlights_ageRestriction__1diyr",
    "body": "Highlights_body__1diyr"
};
